




































	import {Component, Watch} from "vue-property-decorator"
    import AbpBase from "@/lib/abpbase"
    import {QueryPatientEducationPlan } from "@/api/pdOutPatient/pdEducation/pdPatientEdu";
	import {DiagnoseList } from "@/api/pdEducationPlan/pdPatientEducationPlan/index" 
    import addPlan from "./addPlan.vue"
	import show from "./showknowledge.vue"
	@Component({
		components: {addPlan,show}
	})
	export default class EducationPlan extends AbpBase{
		position = '全部'
		data:any = []
		detailData:any = []
		detailShow = false
		showknowledge =false
		showknowledgeData:any = []
		loading = false
		request: any = {
			startTime: '',
			endTime: '',
			type:'',
			hasPlan:'全部',
			hasEvaluate:"全部",
			patientName:""
		};
		diagnoseList:any = []
		columns = [
			 {
				type: "selection",
				width: 60,
				align: "center",
				fixed: "left",
			},
			{
				title: '姓名',
				key: 'patientName',
				width: 200
			},
			{
				title: '诊断',
				key: 'diagnose',
				width: 200
			},
			{
				title: '宣教日期',
				key: 'eduTime',
				width: 220
			},
			{
				title: '标题',
				key: 'knowledgeName',
			},
			{
				title: ' ',
				width: 220,
				render:(h1:any, p:any)=>{
					const h = this.$createElement
					return h('div',[
/* 						h('Button',{
							props: {type: 'primary',size: 'small'},
							style:{marginRight: '10px'},
							on:{
								click:()=>{
									this.detail(p)
								}
							}
						},'详情'), */
						h('Button',{
						 	props: {type: 'primary',size:'small'},
							style:{marginRight: '10px'},
						 	on:{
						 		click:()=>{
						 			this.addPlan(p)
						 		}
						 	}
						 },'添加计划'),
						 h('Button',{
						 	props: {type: 'primary',size:'small'},
							style:{marginRight: '10px'},
						 	on:{
						 		click:()=>{
									this.preview(p.row);
						 		}
						 	}
						 },'预览材料'),
					])

				}
			},
		]
		created(){
			this.select()
			const end = new Date();
			const start = new Date();
			start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
			this.request.startTime=start;
			this.request.endTime=end;
			this.getData()
		
		}

		select(){
			let res = DiagnoseList()
			this.diagnoseList=res.objects;
		}
		async getData(){
			this.loading = true
			this.request.startTime= this.formatDate(this.request.startTime)
			this.request.endTime= this.formatDate(this.request.endTime)
			this.request.type = this.position;
			let res = await QueryPatientEducationPlan(this.request)
			this.data = res.objects
			this.selectedTableRow.forEach((item: any) => {
			if(this.data.find((x:any)=>x.patientId == item.patientId)==null){
				item._checked=true;
				this.data.unshift(item)
			}
			})

			this.loading = false
		}

/* 		private detail(p: any) {
			this.detailData = p.row
			this.detailShow = true
		}
 */
		selectedTableRow: any[] = [];
		tableSelectionChange(selection: any) {
			this.selectedTableRow = selection;
		}
        
		addPlanShow = false
		addPlanData: any = {}
		private addPlan(p: any) {
			this.addPlanData = p.row
			this.addPlanData.AddType="单独"
			this.addPlanShow = true
        }
		preview(row: any) {
			this.showknowledgeData = row
			this.showknowledge = true
    	}
		batchAdd(){
			let patientIdList = this.selectedTableRow.map((row) => {
			return row.patientId;
			});
			console.log(patientIdList)
			this.addPlanData ={
				AddType:"批量",
				patientIdList:patientIdList
			}
			this.addPlanShow = true
        }
		batchclose(){
		this.request.patientName=null;
		this.selectedTableRow=[];
		this.getData();
		}
        changePosition(type:string){
			this.position=type;
			this.getData();
		}
	}
		    



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdOutPatient/pdEducation/pdPatientEducationBatch/index.vue